import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "react-select";
import FilePreview from "components/Common/previewFile";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  ButtonDropdown,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  Label,
  Input,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SectionCard from "components/Common/SectionCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import ReservationList from "components/Common/ReservationListHm";
import ReservationEnCoursList from "components/Common/ReservationEnCoursListHm";
import OperationList from "components/Common/OperationListHm";
import SouscriptionsHmList from "components/Common/SouscriptionsHmList";
import DocumentHm from "components/Common/DocumentHm";
import DocumentFusionHm from "components/Common/DocumentFusionHm";
import Config from "config";
import DeleteButton from "components/Common/DeleteButtonShow";
import LastModificationAlertShow from "components/Common/AlertShow";
import ReactInputMask from "react-input-mask";
import AuditCard from "components/Common/AuditCard";

const InvestorDetail = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [modal_1, setModal_1] = useState(false);
  const [modal_2, setModal_2] = useState(false);
  const [modal_3, setModal_3] = useState(false);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const [investisseursData, setInvestisseursData] = useState([]);
  const [reservationData, setReservationData] = useState([]);
  const [operationData, setOperationData] = useState([]);
  const [souscriptionsData, setSouscriptionsData] = useState([]);
  const [documentData, setDocumentData] = useState([]);
  const [documentFusionData, setDocumentFusionData] = useState([]);
  const [reservationEnCoursData, setReservationEnCoursData] = useState([]);
  const [btnsecondary1, setBtnsecondary1] = useState(false);
  const [docData, setDocData] = useState();
  const [docId, setDocId] = useState("");
  const [selectedCategories, setSelectedCategorie] = useState();
  const handleCategorieChange = (e) => {
    setSelectedCategorie(e);
  };

  const [selectedType, setSelectedType] = useState();
  const handleTypeChange = (e) => {
    setSelectedType(e);
  };
  const [selectedNom, setSelectedNom] = useState();
  const [selectedFichier, setSelectedFichier] = useState();

  const handleFileChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedFichier(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const [selectedComment, setSelectedComment] = useState("");
  // New
  const [newCategories, setNewCategorie] = useState("");
  const [newType, setNewType] = useState("");
  const [newNom, setNewNom] = useState("");
  const [newFichier, setNewFichier] = useState("");
  const [newComment, setNewComment] = useState("");

  const handleNewCategorieChange = (e) => {
    setNewCategorie(e);
  };

  const handleNewTypeChange = (e) => {
    setNewType(e);
  };

  const handleNomChange = (e) => {
    setNewNom(e.target.value);
  };

  const handleNewFileChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setNewFichier(newFile);
    } else {
      setNewFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };

  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  const [wait, setWait] = useState(1000);
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  const handleDropDownActionsClick = async (action) => {
    switch (action.action) {
      case "form_dossier_souscription":
        toast.success(
          "Redirection vers la création de souscription en cours ..."
        );
        navigate(
          `${backUrl}/${action.controlleur}/${action.action}/${action.params.investisseur_id}`
        );
        break;
      case "creation_one_user":
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/investisseurs/creation_one_user?investisseur_id=${id}`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({}),
            }
          );
          if (response.ok) {
            console.log("POST request successful");
            const responseData = await response.json();
            toast.success(responseData?.message);
          } else {
            console.error("POST request failed");
            toast.error("Une erreur s'est produite");
          }
        } catch (error) {
          console.error("An error occurred", error);
          toast.error("Une erreur s'est produite");
        }
        break;
      default:
        toast.error("Aucune action configurée");
        break;
    }
  };
  document.title = "Investisseurs | DETAILS";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            Détails investisseur
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={navStyle}
            onClick={() => handleTabClick("contact")}
            className={`nav-link ${activeTab === "contact" ? "active" : ""}`}
          >
            {!loading ? (
              investisseursData?.detail_investisseur?.identification.Type ==
              "PP" ? (
                "Détails personne physique"
              ) : (
                "Détails personne morale"
              )
            ) : (
              <>
                <h5 className="card-title placeholder-glow">
                  <span
                    style={{ height: "1em" }}
                    className="placeholder col-6"
                  ></span>
                </h5>
              </>
            )}
          </NavLink>
        </NavItem>
        {investisseursData?.hm_accessibles?.map((key, index) =>
          key === "hm_reservations" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "reservation" ? "active" : ""
                }`}
                onClick={() => handleTabClick("reservation")}
              >
                {!loading ? (
                  reservationData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_reservations_en_cours" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "reservations_en_cours" ? "active" : ""
                }`}
                onClick={() => handleTabClick("reservations_en_cours")}
              >
                {!loading ? (
                  reservationEnCoursData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_operations" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "operation" ? "active" : ""
                }`}
                onClick={() => handleTabClick("operation")}
              >
                {!loading ? (
                  operationData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_souscriptions" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "souscriptions" ? "active" : ""
                }`}
                onClick={() => handleTabClick("souscriptions")}
              >
                {!loading ? (
                  souscriptionsData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_documents" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "documents" ? "active" : ""
                }`}
                onClick={() => handleTabClick("documents")}
              >
                {!loading ? (
                  documentData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_documents_fusion" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "documents_fusion" ? "active" : ""
                }`}
                onClick={() => handleTabClick("documents_fusion")}
              >
                {!loading ? (
                  documentFusionData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : null
        )}
      </Nav>
    );
  };
  const getDocumentHm = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/investisseurs/${id}/hm_documents`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setDocumentData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleNewSubmit = async () => {
    if (newCategories?.value == null || "") {
      toast.error("Catégorie ne peut pas être vide");
    } else if (newType?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else if (newFichier == null || "") {
      toast.error("Merci de renseigner un fichier");
    } else {
      document.getElementById("create_button").disabled = true;
      const formData = new FormData();
      formData.append("investisseur_id", id);
      formData.append("fichier", newFichier);
      formData.append("categories_document_id", newCategories?.value);
      formData.append("types_document_id", newType?.value);
      formData.append("nom", newNom);
      formData.append("commentaires", newComment);
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/contact_documents/`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );
        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Document Ajouté");
          setModal_1(false);
          getDocumentHm();
        } else {
          document.getElementById("create_button").disabled = false;
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (responseData && responseData.contact_document_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.contact_document_validation;
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const handleUpdateSubmit = async () => {
    if (selectedCategories?.value == null || "") {
      toast.error("Catégorie ne peut pas être vide");
    } else if (selectedType?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("id", docId);
        formData.append("investisseur_id", id);
        formData.append("fichier", selectedFichier);
        formData.append("categories_document_id", selectedCategories?.value);
        formData.append("types_document_id", selectedType?.value);
        formData.append("nom", selectedNom);
        formData.append("commentaires", selectedComment);
        const response = await fetch(
          `https://www.fluxod.com/${api}/contact_documents/${docId}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Document Modifié");
          getDocumentHm();
          setLoading(false);
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          setLoading(false);
          if (responseData && responseData.contact_document_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.contact_document_validation[0];
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const getDocumentDetail = async (docId) => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/contact_documents/${docId}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setDocData(data);
          setSelectedCategorie(
            data?.detail_contact_document["Identification du documents"][
              "Catégorie"
            ]
          );
          setSelectedType(
            data?.detail_contact_document["Identification du documents"]["Type"]
          );
          setSelectedNom(
            data?.detail_contact_document["Identification du documents"]["Nom"]
          );
          setSelectedFichier(
            data?.detail_contact_document["Identification du documents"][
              "Fichier"
            ]
          );
          setSelectedComment(
            data?.detail_contact_document["Identification du documents"]
              .Commentaires
          );
          setModal(true);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const [categorieData, setCategorieData] = useState({ data: [] });
  const renderCategorieOptions = () => {
    return [
      {
        options: categorieData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getCategorieDocument = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/contact_documents/categories_documents`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();

      if (data?.data?.length === 1) {
        setNewCategorie({ label: data.data[0].label, value: data.data[0].id });
      }

      setCategorieData(data); // Stocker la liste complète
    } catch (error) {
      console.log(error);
    }
  };
  const [typeDocData, setTypeDocData] = useState({ data: [] });
  const renderTypeDocOptions = () => {
    return [
      {
        options: typeDocData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getTypeDoc = async (docId) => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/contact_documents/types_documents?id=${docId}&categories_document_id=${
          selectedCategories?.value || newCategories?.value
        }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setTypeDocData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getTypeDoc();
  }, [selectedCategories, newCategories]);
  useEffect(() => {
    getCategorieDocument();
  }, []);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/investisseurs/${id}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }

        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const investisseursData = await response.json();
        setInvestisseursData(investisseursData);

        {
          investisseursData?.hm_accessibles?.map(async (key, index) =>
            key === "hm_reservations"
              ? await getReservation()
              : key === "hm_operations"
              ? await getOperation()
              : key === "hm_souscriptions"
              ? await getSouscriptionHm()
              : key === "hm_documents"
              ? await getDocumentHm()
              : key === "hm_documents_fusion"
              ? await getDocumentFusionHm()
              : key === "hm_reservations_en_cours"
              ? await getReservationEnCours()
              : null
          );
        }
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };

    const getReservation = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/investisseurs/${id}/hm_reservations`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setReservationData(data);
          });
      } catch (error) {
        console.log(error);
      }
    };
    const getReservationEnCours = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/investisseurs/${id}/hm_reservations_en_cours`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setReservationEnCoursData(data);
          });
      } catch (error) {
        console.log(error);
      }
    };

    const getOperation = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/investisseurs/${id}/hm_operations`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setOperationData(data);
          });
      } catch (error) {
        console.log(error);
      }
    };
    const getSouscriptionHm = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/investisseurs/${id}/hm_souscriptions`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setSouscriptionsData(data);
          });
      } catch (error) {
        console.log(error);
      }
    };
    const getDocumentHm = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/investisseurs/${id}/hm_documents`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setDocumentData(data);
          });
      } catch (error) {
        console.log(error);
      }
    };
    const getDocumentFusionHm = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/investisseurs/${id}/hm_documents_fusion`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setDocumentFusionData(data);
            setWait(0);
          });
      } catch (error) {
        console.log(error);
      }
    };

    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);
  const [operationTypeData, setOperationTypeData] = useState([]);
  const getOperationType = async () => {
    try {
      await fetch(`https://www.fluxod.com/${api}/operations/operation_types`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setOperationTypeData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderOperationTypeOptions = () => {
    return [
      {
        options: operationTypeData?.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const [pmeData, setPmeData] = useState([]);
  const getPme = async () => {
    try {
      await fetch(`https://www.fluxod.com/${api}/operations/pmes`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setPmeData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderInvestisseurOptions = () => {
    return [
      {
        options: pmeData?.data?.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  // New opération
  const [newDate, setNewDate] = useState("");
  const [newTypeOp, setNewTypeOp] = useState("");
  const [newQuantite, setNewQuantite] = useState("");
  const [newPrix, setNewPrix] = useState("");
  const [newCreeLe, setNewCreeLe] = useState("");
  const [newInvestisseur, setNewInvestisseur] = useState("");
  const handleNewTypeOpChange = (e) => {
    setNewTypeOp(e);
  };

  const handleNewInvestisseurChange = (e) => {
    setNewInvestisseur(e);
  };

  const handleNewQuantiteChange = (e) => {
    setNewQuantite(e.target.value);
  };
  const handleNewDateChange = (e) => {
    setNewDate(e.target.value);
  };
  const handleNewPrixChange = (e) => {
    setNewPrix(e.target.value);
  };
  const handleNewCreeLeChange = (e) => {
    setNewCreeLe(e.target.value);
  };
  //// Edit opération
  const [editDate, setEditDate] = useState("");
  const [editTypeOp, setEditTypeOp] = useState("");
  const [editQuantite, setEditQuantite] = useState("");
  const [editPrix, setEditPrix] = useState("");
  const [editCreeLe, setEditCreeLe] = useState("");
  const [editInvestisseur, setEditInvestisseur] = useState("");
  const handleEditTypeOpChange = (e) => {
    setEditTypeOp(e);
  };

  const handleEditInvestisseurChange = (e) => {
    setEditInvestisseur(e);
  };

  const handleEditQuantiteChange = (e) => {
    setEditQuantite(e.target.value);
  };
  const handleEditDateChange = (e) => {
    setEditDate(e.target.value);
  };
  const handleEditPrixChange = (e) => {
    setEditPrix(e.target.value);
  };
  const handleEditCreeLeChange = (e) => {
    setNewCreeLe(e.target.value);
  };
  const handleNewOperationSubmit = async () => {
    if (newTypeOp?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else if (newInvestisseur?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/operations/`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              pme_id: newInvestisseur?.value,
              operation_type_id: newTypeOp?.value,
              investisseur_id: id,
              date: newDate,
              quantite: newQuantite,
              prix: newPrix,
            }),
          }
        );
        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Opération Ajoutée");
          setModal_2(false);
          try {
            await fetch(
              `https://www.fluxod.com/${api}/investisseurs/${id}/hm_operations`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            )
              .then((response) => response.json())
              .then((data) => {
                setOperationData(data);
                setWait(0);
              });
          } catch (error) {
            console.log(error);
          }
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (responseData && responseData.operation_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.operation_validation;
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const handleUpdateOperationSubmit = async () => {
    if (editTypeOp?.value == null || "") {
      toast.error("Type ne peut pas être vide");
    } else if (editInvestisseur?.value == null || "") {
      toast.error("PME ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/operations/${opId}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              id: opId,
              pme_id: editInvestisseur?.value,
              operation_type_id: editTypeOp?.value,
              investisseur_id: id,
              date: editDate,
              quantite: editQuantite,
              prix: editPrix,
            }),
          }
        );
        if (response.ok) {
          console.log("PATCH request successful");
          toast.success("Opération modifiée");
          setModal_3(false);
          try {
            await fetch(
              `https://www.fluxod.com/${api}/investisseurs/${id}/hm_operations`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            )
              .then((response) => response.json())
              .then((data) => {
                setOperationData(data);
                setWait(0);
              });
          } catch (error) {
            console.log(error);
          }
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (responseData && responseData.operation_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData.operation_validation;
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const [opId, setOpId] = useState("");
  const getOperationDetail = async (opId) => {
    try {
      await fetch(`https://www.fluxod.com/${api}/operations/${opId}/edit`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          // setSelectedPme(data?.detail_operation["Identification"]["PME"]);
          setEditTypeOp(data?.detail_operation["Identification"]["Type"]);
          setEditInvestisseur(data?.detail_operation["Identification"]["PME"]);
          setEditQuantite(data?.detail_operation["Identification"]["Quantité"]);
          setEditDate(data?.detail_operation["Identification"]["Date"]);
          setEditPrix(data?.detail_operation["Identification"].Prix);
          setModal_3(true);
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getPme();
    getOperationType();
  }, []);
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }

  function extractSegment(url) {
    const baseUrl = `${backUrl}/`;
    const editSegment = "/edit";

    // Check if the URL starts with the base URL and ends with the edit segment
    if (url.startsWith(baseUrl) && url.endsWith(editSegment)) {
      // Extract the part of the URL between base URL and edit segment
      const start = baseUrl.length;
      const end = url.length - editSegment.length;
      return url.substring(start, end);
    }

    return null;
  }
  const lastId = localStorage.getItem("lastId");
  const previousPath = localStorage.getItem("previousPath_" + api);

  const extractedText = extractSegment(previousPath);
  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        {previousPath == `${backUrl}/${extractedText}/edit` ? (
          <LastModificationAlertShow path={extractedText} />
        ) : null}
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/investisseurs/`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        Investisseurs
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        investisseursData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {investisseursData?.can_edit ? (
                        <Link
                          to={`${backUrl}/investisseurs/${id}/edit`}
                          state={linkState}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      {investisseursData?.can_destroy ? (
                        <>
                          &nbsp; &nbsp;
                          <DeleteButton
                            url={`https://www.fluxod.com/${api}/investisseurs/${id}`}
                          />
                        </>
                      ) : null}
                      {investisseursData?.actions?.length > 0 ? (
                        <>
                          &nbsp; &nbsp;
                          <Dropdown
                            isOpen={btnsecondary1}
                            toggle={() => setBtnsecondary1(!btnsecondary1)}
                          >
                            <DropdownToggle
                              tag="button"
                              className="btn btn-sm btn-secondary"
                            >
                              Actions <i className="mdi mdi-chevron-down" />
                            </DropdownToggle>
                            <DropdownMenu>
                              {investisseursData?.actions.map(
                                (value, index) => (
                                  <>
                                    <DropdownItem
                                      onClick={() =>
                                        handleDropDownActionsClick(value.action)
                                      }
                                    >
                                      {value.label}
                                    </DropdownItem>
                                  </>
                                )
                              )}
                            </DropdownMenu>
                          </Dropdown>
                        </>
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            {investisseursData?.detail_investisseur
                              ?.identification ? (
                              <Col sm="6">
                                <IdentificationCard
                                  title="Identification"
                                  details={
                                    investisseursData?.detail_investisseur
                                      ?.identification
                                  }
                                  ids={
                                    investisseursData?.detail_investisseur?.ids
                                  }
                                />
                              </Col>
                            ) : (
                              ""
                            )}

                            <Col sm="6">
                              {investisseursData?.detail_investisseur
                                ?.souscriptions ? (
                                <IdentificationCard
                                  title="Souscriptions"
                                  details={
                                    investisseursData?.detail_investisseur
                                      ?.souscriptions
                                  }
                                />
                              ) : null}

                              {investisseursData?.detail_investisseur
                                ?.details ? (
                                <IdentificationCard
                                  title="Détails"
                                  details={
                                    investisseursData?.detail_investisseur
                                      ?.details
                                  }
                                />
                              ) : null}
                            </Col>
                          </Row>
                          {investisseursData?.detail_investisseur?.audit ? (
                            <Row>
                              <Col sm="12">
                                <AuditCard
                                  title="Audit"
                                  auditData={
                                    investisseursData?.detail_investisseur
                                      ?.audit
                                  }
                                />
                              </Col>
                            </Row>
                          ) : null}
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {/* Reservation */}
                  {activeTab === "reservation" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <ReservationList
                            investisseur_name={investisseursData.sil}
                            partenaire_id={
                              investisseursData?.detail_investisseur?.ids
                                ?.Partenaire
                            }
                            title={reservationData}
                            data={reservationData.data}
                            header={reservationData.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "operation" && (
                    <div>
                      {!loading ? (
                        <>
                          {operationData?.can_add ? (
                            <div style={{ textAlign: "left" }}>
                              <Link
                                id={`edittooltip-}`}
                                className="btn btn-sm btn-primary"
                                onClick={() => setModal_2(true)}
                              >
                                <i className="bx bx-plus"></i>Ajouter
                              </Link>
                            </div>
                          ) : null}
                          <OperationList
                            title={operationData}
                            data={operationData.data}
                            header={operationData.header}
                            itemsPerPage={10}
                            onClick={(documentId) => {
                              getOperationDetail(documentId);
                              setOpId(documentId);
                            }}
                          />
                          <Modal
                            isOpen={modal_2}
                            toggle={() => setModal_2(!modal_2)}
                          >
                            <ModalHeader
                              toggle={() => setModal_2(!modal_2)}
                              tag="h4"
                            >
                              Nouvelle opération
                            </ModalHeader>
                            <ModalBody>
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  handleNewOperationSubmit();
                                }}
                              >
                                <Row>
                                  <Col className="col-12">
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Investisseur
                                      </Label>
                                      <Input
                                        name="investisseur"
                                        type="text"
                                        placeholder="Investisseur"
                                        value={investisseursData.sil}
                                        readOnly
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Type</Label>
                                      <Select
                                        defaultValue={newType}
                                        onChange={handleNewTypeOpChange}
                                        options={renderOperationTypeOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">PME</Label>
                                      <Select
                                        defaultValue={newInvestisseur}
                                        onChange={handleNewInvestisseurChange}
                                        options={renderInvestisseurOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Date</Label>
                                      <ReactInputMask
                                        mask="99/99/9999"
                                        value={newDate}
                                        className="form-control input-color"
                                        onChange={(dateString) => {
                                          setNewDate(dateString.target.value);
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Prix</Label>
                                      <Input
                                        name="prix"
                                        type="number"
                                        placeholder="Prix"
                                        value={newPrix}
                                        onChange={(e) =>
                                          setNewPrix(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Quantité
                                      </Label>
                                      <Input
                                        name="quantite"
                                        type="number"
                                        placeholder="Quantité"
                                        value={newQuantite}
                                        onChange={(e) =>
                                          setNewQuantite(e.target.value)
                                        }
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="text-end">
                                      <button
                                        type="submit"
                                        id="create_button"
                                        className="btn btn-success save-user"
                                      >
                                        Créer
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </ModalBody>
                          </Modal>
                          <Modal
                            isOpen={modal_3}
                            toggle={() => setModal_3(!modal_3)}
                          >
                            <ModalHeader
                              toggle={() => setModal_3(!modal_3)}
                              tag="h4"
                            >
                              Modification de l'opération
                            </ModalHeader>
                            <ModalBody>
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  handleUpdateOperationSubmit();
                                }}
                              >
                                <Row>
                                  <Col className="col-12">
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Investisseur
                                      </Label>
                                      <Input
                                        name="investisseur"
                                        type="text"
                                        placeholder="Investisseur"
                                        value={investisseursData.sil}
                                        readOnly
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Type</Label>
                                      <Select
                                        defaultValue={editTypeOp}
                                        onChange={handleEditTypeOpChange}
                                        options={renderOperationTypeOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">PME</Label>
                                      <Select
                                        defaultValue={editInvestisseur}
                                        onChange={handleEditInvestisseurChange}
                                        options={renderInvestisseurOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Date</Label>
                                      <ReactInputMask
                                        mask="99/99/9999"
                                        value={editDate}
                                        className="form-control input-color"
                                        onChange={(dateString) => {
                                          setEditDate(dateString.target.value);
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Prix</Label>
                                      <Input
                                        name="prix"
                                        type="number"
                                        placeholder="Prix"
                                        value={editPrix}
                                        onChange={(e) =>
                                          setEditPrix(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Quantité
                                      </Label>
                                      <Input
                                        name="quantite"
                                        type="number"
                                        placeholder="Quantité"
                                        value={editQuantite}
                                        onChange={(e) =>
                                          setEditQuantite(e.target.value)
                                        }
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="text-end">
                                      <button
                                        type="submit"
                                        id="create_button"
                                        className="btn btn-success save-user"
                                      >
                                        Modifier
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </ModalBody>
                          </Modal>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "souscriptions" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <SouscriptionsHmList
                            title={souscriptionsData}
                            data={souscriptionsData.data}
                            header={souscriptionsData.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "documents" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          {documentData?.can_add ? (
                            <div style={{ textAlign: "left" }}>
                              <Link
                                id={`edittooltip-}`}
                                className="btn btn-sm btn-primary"
                                onClick={() => setModal_1(true)}
                              >
                                <i className="bx bx-plus"></i>Ajouter
                              </Link>
                            </div>
                          ) : null}

                          <DocumentHm
                            title={documentData}
                            data={documentData.data}
                            header={documentData.header}
                            itemsPerPage={10}
                            onClick={(documentId) => {
                              getDocumentDetail(documentId);
                              getTypeDoc(documentId);
                              setDocId(documentId);
                            }}
                            controller="contact_documents"
                          />
                          <Modal isOpen={modal} toggle={() => setModal(!modal)}>
                            <ModalHeader
                              toggle={() => setModal(!modal)}
                              tag="h4"
                            >
                              Détails du document
                            </ModalHeader>
                            <ModalBody>
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  setModal(false);
                                  handleUpdateSubmit();
                                }}
                              >
                                <Row>
                                  <Col className="col-12">
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Investisseur
                                      </Label>
                                      <Input
                                        name="investisseur"
                                        type="text"
                                        placeholder="Nom de l'investisseur"
                                        value={
                                          docData?.detail_contact_document[
                                            "Identification du documents"
                                          ]["Investisseur"]
                                        }
                                        readOnly
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Catégorie
                                      </Label>
                                      <Select
                                        defaultValue={selectedCategories}
                                        onChange={handleCategorieChange}
                                        options={renderCategorieOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Type</Label>
                                      <Select
                                        defaultValue={selectedType}
                                        onChange={handleTypeChange}
                                        options={renderTypeDocOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Nom</Label>
                                      <Input
                                        name="nom"
                                        type="text"
                                        placeholder="Nom du document"
                                        value={selectedNom}
                                        onChange={(e) =>
                                          setSelectedNom(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Commentaires
                                      </Label>
                                      <Input
                                        name="commentaire"
                                        type="text"
                                        placeholder="Commentaires"
                                        value={selectedComment}
                                        onChange={(e) =>
                                          setSelectedComment(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Fichier :
                                      </Label>
                                      <FilePreview
                                        fileUrl={
                                          docData?.detail_contact_document[
                                            "Identification du documents"
                                          ]["Fichier"]
                                        }
                                      />
                                      <a
                                        href={
                                          docData?.detail_contact_document[
                                            "Identification du documents"
                                          ]["Fichier"]
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Télécharger le fichier
                                      </a>
                                      <input
                                        type="file"
                                        onChange={handleFileChange}
                                        style={{
                                          display: "block",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="text-end">
                                      <button
                                        type="submit"
                                        className="btn btn-success save-user"
                                      >
                                        Enregistrer
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </ModalBody>
                          </Modal>
                          <Modal
                            isOpen={modal_1}
                            toggle={() => setModal_1(!modal_1)}
                          >
                            <ModalHeader
                              toggle={() => setModal_1(!modal_1)}
                              tag="h4"
                            >
                              Nouveau document
                            </ModalHeader>
                            <ModalBody>
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  handleNewSubmit();
                                }}
                              >
                                <Row>
                                  <Col className="col-12">
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Investisseur
                                      </Label>
                                      <Input
                                        name="investisseur"
                                        type="text"
                                        placeholder="Nom de l'investisseur"
                                        value={investisseursData.sil}
                                        readOnly
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Catégorie
                                      </Label>
                                      <Select
                                        defaultValue={newCategories}
                                        onChange={handleNewCategorieChange}
                                        options={renderCategorieOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Type</Label>
                                      <Select
                                        defaultValue={newType}
                                        onChange={handleNewTypeChange}
                                        options={renderTypeDocOptions()}
                                        isClearable={true}
                                        className="select2"
                                        styles={{
                                          control: (provided, state) => ({
                                            ...provided,

                                            boxShadow: state.isFocused
                                              ? "none"
                                              : "none", // Supprimer l'ombre lorsque le composant est en focus
                                            "&:hover": {
                                              borderColor: "#555B21", // Couleur de la bordure au survol
                                            },
                                          }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isSelected
                                              ? "#ebd826"
                                              : "white", // Couleur d'arrière-plan de l'option sélectionnée
                                            color: state.isSelected
                                              ? "#212529"
                                              : "black", // Couleur du texte de l'option sélectionnée
                                          }),
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">Nom</Label>
                                      <Input
                                        name="nom"
                                        type="text"
                                        placeholder="Nom du document"
                                        value={newNom}
                                        onChange={handleNomChange}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Commentaires
                                      </Label>
                                      <Input
                                        name="commentaire"
                                        type="text"
                                        placeholder="Commentaires"
                                        value={newComment}
                                        onChange={(e) =>
                                          setNewComment(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        Fichier
                                      </Label>

                                      <input
                                        type="file"
                                        onChange={handleNewFileChange}
                                        style={{
                                          display: "block",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="text-end">
                                      <button
                                        type="submit"
                                        id="create_button"
                                        className="btn btn-success save-user"
                                      >
                                        Créer
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </ModalBody>
                          </Modal>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={100000} />
                      )}
                    </div>
                  )}
                  {activeTab === "documents_fusion" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <DocumentFusionHm
                            title={documentFusionData}
                            data={documentFusionData.data}
                            header={documentFusionData.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "reservations_en_cours" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <ReservationEnCoursList
                            title={reservationEnCoursData}
                            data={reservationEnCoursData.data}
                            header={reservationEnCoursData.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                  {activeTab === "contact" && (
                    <div>
                      {!loading &&
                      investisseursData?.detail_investisseur?.identification
                        .Type == "PP" ? (
                        <>
                          <Row>
                            <Col sm="6">
                              <IdentificationCard
                                title="Identification"
                                details={
                                  investisseursData?.detail_nom_investisseur
                                    ?.identification
                                }
                                ids={
                                  investisseursData?.detail_nom_investisseur
                                    ?.ids
                                }
                              />
                            </Col>
                            <Col sm="6">
                              <IdentificationCard
                                title="Renseignements Divers"
                                details={
                                  investisseursData?.detail_nom_investisseur
                                    ?.renseignements_divers
                                }
                                ids={
                                  investisseursData?.detail_nom_investisseur
                                    ?.ids
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="12">
                              <TableComponent
                                title={"Adresses"}
                                header={
                                  investisseursData?.detail_nom_investisseur
                                    ?.adresses_postales?.Adresses.header
                                }
                                data={
                                  investisseursData?.detail_nom_investisseur
                                    ?.adresses_postales?.Adresses.data
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <TableComponent
                                title={"Emails"}
                                header={
                                  investisseursData?.detail_nom_investisseur
                                    ?.adresses_email?.Emails.header
                                }
                                data={
                                  investisseursData?.detail_nom_investisseur
                                    ?.adresses_email?.Emails.data
                                }
                                hideTableHeader={true}
                              />
                            </Col>
                            <Col sm="6">
                              <TableComponent
                                title={"Numéros"}
                                header={
                                  investisseursData?.detail_nom_investisseur
                                    ?.numeros_de_telephone?.Téléphones.header
                                }
                                data={
                                  investisseursData?.detail_nom_investisseur
                                    ?.numeros_de_telephone?.Téléphones.data
                                }
                                hideTableHeader={true}
                              />
                            </Col>
                          </Row>
                        </>
                      ) : // Si le type est égal à PM (Personne morale)
                      !loading &&
                        investisseursData?.detail_investisseur?.identification
                          .Type == "PM" ? (
                        <>
                          <Row>
                            <Col sm="6">
                              <IdentificationCard
                                title="Identification"
                                details={
                                  investisseursData?.detail_nom_investisseur
                                    ?.identification
                                }
                                ids={
                                  investisseursData?.detail_nom_investisseur
                                    ?.ids
                                }
                              />
                            </Col>
                            <Col sm="6">
                              <IdentificationCard
                                title="Contact"
                                details={
                                  investisseursData?.detail_nom_investisseur
                                    ?.contact
                                }
                                ids={
                                  investisseursData?.detail_nom_investisseur
                                    ?.ids
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <IdentificationCard
                                title="Caractéristique"
                                details={
                                  investisseursData?.detail_nom_investisseur
                                    ?.caracteristiques
                                }
                                ids={
                                  investisseursData?.detail_nom_investisseur
                                    ?.ids
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="12">
                              <TableComponent
                                title={"Adresses"}
                                header={
                                  investisseursData?.detail_nom_investisseur
                                    ?.adresses?.Adresses.header
                                }
                                data={
                                  investisseursData?.detail_nom_investisseur
                                    ?.adresses?.Adresses.data
                                }
                              />
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default InvestorDetail;
